"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const Buttons_1 = require("../../../common/Buttons");
function Popup(props) {
    const { addBottomPadding, showCloseIcon, className, onDismiss, noHeader, alignLeft } = props;
    const onCloseClicked = () => {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    const contentStyle = addBottomPadding ? { paddingBottom: '30px' } : {};
    return (react_1.default.createElement("div", { className: "popup full-screen-overlay" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('popup-content', 'content', className, { 'popup-no-header': noHeader, alignLeft }), style: contentStyle },
            react_1.default.createElement("div", { className: "login-form-header" }, showCloseIcon && (react_1.default.createElement(Buttons_1.PictureButton, { buttonType: Buttons_1.ButtonTypes.Close, className: "popup-close-button", onClick: onCloseClicked }))),
            react_1.default.createElement("div", { className: "popupBody" }, props.children))));
}
(function (Popup) {
    Popup.propTypes = {
        addBottomPadding: prop_types_1.default.bool,
        className: prop_types_1.default.string,
        onDismiss: prop_types_1.default.func,
        showCloseIcon: prop_types_1.default.bool,
    };
})(Popup || (Popup = {}));
exports.default = Popup;
